import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'
import { COLORS } from '../data/enums'

export default function FaceFeature({
  scaleX,
  scale,
  gradient,
  pupil,
  rotation = 0,
  spacing = 0,
  verticalOffset,
  outline,
  showEyeLiner,
}) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  const leftPupilTransformOrigin = '16.2 14.07'
  const rightPupilTransformOrigin = '41.70 14.07'
  return (
    <>
      <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
        {/* LEFT EYE */}
        <g transform={`scale(${scale},${scale}) translate(${-spacing})`} transform-origin={leftPupilTransformOrigin}>
          <g transform={`rotate(${rotation})`} transform-origin="inherit">
            <path
              className="cls-2"
              d="M14.96,21.56c4,0,7.25-3.13,7.25-7s-3.25-7-7.25-7-7.25,3.13-7.25,7,3.25,7,7.25,7Z"
              fill={COLORS.WHITE}
            />
            <path
              className="cls-3"
              d="M14.96,22.06c-4.27,0-7.75-3.36-7.75-7.5s3.48-7.5,7.75-7.5,7.75,3.36,7.75,7.5-3.48,7.5-7.75,7.5Zm0-14c-3.72,0-6.75,2.92-6.75,6.5s3.03,6.5,6.75,6.5,6.75-2.92,6.75-6.5-3.03-6.5-6.75-6.5Z"
              fill={outline}
            />
          </g>
          <path
            className="cls-1"
            d="M16.21,19.56c3.04,0,5.5-2.46,5.5-5.5s-2.46-5.5-5.5-5.5-5.5,2.46-5.5,5.5,2.46,5.5,5.5,5.5Z"
            fill={`url(#${randomGradientId1})`}
          />
          <g transform={`rotate(${rotation})`} transform-origin="inherit">
            <path
              className="cls-4"
              d="M16.2,16.82c1.52,0,2.75-1.23,2.75-2.75s-1.23-2.75-2.75-2.75-2.75,1.23-2.75,2.75,1.23,2.75,2.75,2.75Z"
              fill={pupil}
            />
            {showEyeLiner && (
              <path d="M22.71,14.56c-1.72-8.08-13.78-8.08-15.5,0-.39-1.95,.51-4.11,2.01-5.54,4.68-4.86,14.33-1.51,13.48,5.54h0Z" />
            )}
          </g>
          <path
            className="cls-2"
            d="M18.04,13.14c.51,0,.92-.41,.92-.92s-.41-.92-.92-.92-.92,.41-.92,.92,.41,.92,.92,.92Z"
            fill={COLORS.WHITE}
          />
        </g>
        {/* RIGHT EYE */}
        <g transform={`scale(${scale},${scale}) translate(${spacing})`} transform-origin={rightPupilTransformOrigin}>
          <g transform={`rotate(${-rotation})`} transform-origin="inherit">
            <path
              className="cls-2"
              d="M42.96,21.56c-4,0-7.25-3.13-7.25-7s3.25-7,7.25-7,7.25,3.13,7.25,7-3.25,7-7.25,7Z"
              fill={COLORS.WHITE}
            />
            <path
              className="cls-3"
              d="M42.96,22.06c-4.27,0-7.75-3.36-7.75-7.5s3.48-7.5,7.75-7.5,7.75,3.36,7.75,7.5-3.48,7.5-7.75,7.5Zm0-14c-3.72,0-6.75,2.92-6.75,6.5s3.03,6.5,6.75,6.5,6.75-2.92,6.75-6.5-3.03-6.5-6.75-6.5Z"
              fill={outline}
            />
          </g>
          <path
            className="cls-5"
            d="M41.71,19.56c3.04,0,5.5-2.46,5.5-5.5s-2.46-5.5-5.5-5.5-5.5,2.46-5.5,5.5,2.46,5.5,5.5,5.5Z"
            fill={`url(#${randomGradientId2})`}
          />
          <g transform={`rotate(${-rotation})`} transform-origin="inherit">
            <path
              className="cls-4"
              d="M41.7,16.82c1.52,0,2.75-1.23,2.75-2.75s-1.23-2.75-2.75-2.75-2.75,1.23-2.75,2.75,1.23,2.75,2.75,2.75Z"
              fill={pupil}
            />
            {showEyeLiner && (
              <path d="M50.7,14.56c-1.72-8.08-13.78-8.08-15.5,0-.39-1.95,.51-4.11,2.01-5.54,4.68-4.86,14.33-1.51,13.48,5.54h0Z" />
            )}
          </g>
          <path
            className="cls-2"
            d="M43.54,13.14c.51,0,.92-.41,.92-.92s-.41-.92-.92-.92-.92,.41-.92,.92,.41,.92,.92,.92Z"
            fill={COLORS.WHITE}
          />
        </g>
      </g>

      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="16.21"
          y1="178.21"
          x2="16.21"
          y2="189.55"
          gradientTransform="translate(0 198) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".27" stopColor={gradient[1]} />
          <stop offset="1" stopColor={gradient[0]} />
        </linearGradient>
        <linearGradient
          id={randomGradientId2}
          x1="41.71"
          x2="41.71"
          y1="178.21"
          y2="189.55"
          gradientTransform="translate(0 198) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".27" stopColor={gradient[1]} />
          <stop offset="1" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </>
  )
}
